@if (data$ | async; as component) {
  <div class="outlet-grid-container container">
    <div class="outlet-container">
      @switch (component.titleTag) {
        @case ('H1') {
          <h1
            class="h2-component title"
            [style.font-size]="component.titleSize + 'px'"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h1>
        }
        @case ('H2') {
          <h2
            class="h2-component title"
            [style.font-size]="component.titleSize + 'px'"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h2>
        }
        @default {
          <div
            class="h2-component"
            [style.font-size]="component.titleSize + 'px'"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </div>
        }
      }
      <div class="products-container">
        @if ( products$ | async; as products) {
          @for (product of products; track product; let i = $index) {
            @if ( product | async; as prod) {
              <div [class]="'outlet-product product-'+i">
                <app-custom-product-item [item]="prod"></app-custom-product-item>
              </div>
            }
          }
        }
      </div>
      @if (component.textButton && component.urlButton) {
        <div class="btn btn-white">
          <a [routerLink]="component.urlButton">
            {{component.textButton}}
          </a>
        </div>
      }
    </div>
  </div>
}
